import AppStoreContext from 'contexts/AppStoreContext';
import React, { useState, useContext } from 'react';
import { useTranslator } from '@bluebeam/react-i18n';
import FileDownloadRow from './FileDownloadRow';
import FileManagerCounters from './FileManagerCounters';

const ExportTab: React.FC = () => {
  const { state } = useContext(AppStoreContext);
  const { translate } = useTranslator(['fileManagerModalFC']);
  const [inProgressCount, setInProgressCount] = useState<number>(0);

  const onDownloadStart = (): void => {
    setInProgressCount(inProgressCount + 1);
  };

  const onDownloadDone = (): void => {
    setInProgressCount(inProgressCount - 1);
  };

  const { activeExports } = state;

  const allUploadCount = activeExports.size;
  const errorCount = 0;

  return (
    <div id="file-manager-modal-exports-tab" className="oh column h100 w100">
      <FileManagerCounters
        label={translate('fileManagerModalFC:exports')}
        allCount={allUploadCount}
        errorCount={errorCount}
        inProgressCount={inProgressCount}
      />
      <div
        className="mx5 thin column bgd-gray-2 font-size-4 medium"
        style={{
          flex: '5 5 100%',
          overflowY: 'auto',
          borderTopLeftRadius: '8px',
          borderTopRightRadius: '8px',
          border: 'solid 0.5px #dcdfe3',
          borderBottomColor: 'transparent',
          color: '#363d43',
        }}
      >
        {activeExports.valueSeq().map((d) => (
          <div
            key={d.fileid}
            className="column center"
            style={{ height: '64px' }}
          >
            <FileDownloadRow
              key={d.fileid}
              filename={d.filename}
              url={d.url}
              onDownloadDone={onDownloadDone}
              onDownloadStart={onDownloadStart}
            />
          </div>
        ))}
      </div>
    </div>
  );
};

export default ExportTab;
